/** Pure helpers for the host location the targeting matcher runs against. */
export interface HostLocation {
  /** `https://host[:port]`, or "" when unknown (iframe opened without `?referer=`). */
  origin: string;
  /** Full host URL, or "" when unknown. */
  url: string;
}

export interface LocationOverride {
  origin?: string;
  path?: string;
}

export function parseHostLocation(href: string): HostLocation {
  try {
    const u = new URL(href);
    return { origin: u.origin, url: u.href };
  } catch {
    return { origin: "", url: "" };
  }
}

/**
 * Applies the private `audienceOverride` origin/path on top of the real location, for matching
 * only. A bare `path` keeps the real origin; a bare `origin` keeps the real path.
 */
export function applyLocationOverride(
  real: HostLocation,
  override: LocationOverride | undefined,
): HostLocation {
  if (!override || (override.origin === undefined && override.path === undefined)) return real;
  const origin = override.origin ?? real.origin;
  let path = override.path;
  if (path === undefined) {
    try {
      const u = new URL(real.url);
      path = `${u.pathname}${u.search}`;
    } catch {
      path = "/";
    }
  }
  if (!path.startsWith("/")) path = `/${path}`;
  return { origin, url: `${origin}${path}` };
}
